import type { RunDoc } from '@mct/shared';
import { Badge } from '../ui/Badge';

export function RunSelector({
  runs,
  selectedRunId,
  onChange,
}: {
  runs: readonly RunDoc[];
  selectedRunId: string | null;
  onChange: (id: string | null) => void;
}) {
  if (runs.length === 0) {
    return (
      <Badge tone="slate" className="whitespace-nowrap">
        フェーズ未作成
      </Badge>
    );
  }
  return (
    <label className="flex items-center gap-2 whitespace-nowrap text-sm">
      <span className="text-slate-500">フェーズ:</span>
      <select
        className="input !py-1"
        value={selectedRunId ?? ''}
        onChange={(e) => onChange(e.target.value || null)}
      >
        <option value="">（選択してください）</option>
        {runs.map((r) => (
          <option key={r.runId} value={r.runId}>
            {r.name} {r.executionsReady ? '' : '(準備中)'}
          </option>
        ))}
      </select>
    </label>
  );
}
